import Steps from './steps';
import Step from './step';

Steps.Step = Step;

export default Steps;
